import { render } from "./CallView.vue?vue&type=template&id=0cd8868d&scoped=true"
import script from "./CallView.vue?vue&type=script&lang=js"
export * from "./CallView.vue?vue&type=script&lang=js"

import "./CallView.vue?vue&type=style&index=0&id=0cd8868d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd8868d"]])

export default __exports__